import { RouteConfig } from 'vue-router';

const Patient = () => import('./views/patient/patient.vue');
const Gauge = () => import('./views/gauge/gauge.vue');


const routers: RouteConfig[] = [
    {
        path: 'patient',
        name: 'patient',
        component: Patient
    },
    {
        path: 'gauge',
        name: 'gauge',
        component: Gauge
    },
    {
        path: '',
        redirect: 'patient'
    },
];

export default routers;

